import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    phone_number: '',
    email: '',
    password: '',
    password2: '',
    chinese_name: '',
    english_name: '',
    district: '',
    birth_year: '',
  });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({});
    setLoading(true);

    const result = await register(formData);

    if (result.success) {
      navigate('/member');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card">
          <h1>會員註冊</h1>
          {error.detail && <div className="alert alert-error">{error.detail}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>中文姓名 *</label>
              <input
                type="text"
                name="chinese_name"
                value={formData.chinese_name}
                onChange={handleChange}
                required
              />
              {error.chinese_name && <span className="error-text">{error.chinese_name}</span>}
            </div>

            <div className="form-group">
              <label>英文姓名</label>
              <input
                type="text"
                name="english_name"
                value={formData.english_name}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>電話號碼 *</label>
              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder="例如: 91234567"
                required
              />
              {error.phone_number && <span className="error-text">{error.phone_number}</span>}
            </div>

            <div className="form-group">
              <label>電郵地址</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>地區</label>
              <select
                name="district"
                value={formData.district}
                onChange={handleChange}
              >
                <option value="">請選擇地區</option>
                <option value="香港仔">香港仔</option>
                <option value="鴨脷洲">鴨脷洲</option>
                <option value="黃竹坑">黃竹坑</option>
                <option value="薄扶林">薄扶林</option>
                <option value="田灣">田灣</option>
                <option value="石排灣">石排灣</option>
                <option value="其他">其他</option>
              </select>
            </div>

            <div className="form-group">
              <label>出生年份 *</label>
              <select
                name="birth_year"
                value={formData.birth_year}
                onChange={handleChange}
                required
              >
                <option value="">請選擇年份</option>
                {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>密碼 *</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              {error.password && <span className="error-text">{error.password}</span>}
            </div>

            <div className="form-group">
              <label>確認密碼 *</label>
              <input
                type="password"
                name="password2"
                value={formData.password2}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary btn-large" disabled={loading}>
              {loading ? '註冊中...' : '註冊'}
            </button>
          </form>
          <div className="auth-footer">
            <p>已經是會員？ <Link to="/login">立即登入</Link></p>
            <Link to="/">返回首頁</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
